import React from "react";

// Pair of flickering candle flames anchored to the bottom of a section.
// Pure CSS, no images.
export const Candles = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute bottom-0 left-0 right-0 flex justify-between px-6 sm:px-16"
      data-testid="kek-candles"
    >
      <Flame />
      <Flame delay="-1.2s" />
    </div>
  );
};

const Flame = ({ delay = "0s" }) => (
  <div
    className="kek-flicker"
    style={{
      width: 22,
      height: 44,
      borderRadius: "50% 50% 45% 45% / 60% 60% 40% 40%",
      background:
        "radial-gradient(ellipse at 50% 70%, #ffd27a 0%, #e8943a 35%, #8a3a12 70%, transparent 80%)",
      boxShadow:
        "0 0 30px 6px rgba(232,148,58,0.45), 0 0 60px 14px rgba(107,47,179,0.25)",
      animationDelay: delay,
    }}
  />
);

export default Candles;
